import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";
import "./thankyou.css";

function Thankyou() {
  const navigate = useNavigate();
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");
  }, []);
  const handleClick = () => {
    ctaClickEvent(
      "Back",
      "thank you page",
      "button",
      0,
      "https://campaigns.icici.bank.in/seniorCitizenBanking/awareness/index.html",
    );

    navigate("/");
  };

  return (
    <>
      <section>
        <div className="container">
          <div className="thank-you">
            <div className="margin-top" style={{ position: "relative" }}>
              <h2 className="">
                Thank you for your interest in <br /> ICICI Bank Senior Citizen
                Solution
              </h2>
              <div className="popup-icon">
                <img
                  src={process.env.PUBLIC_URL + "/dist/img/icon15.webp"}
                  width="89"
                  height="84"
                  alt="Thanks"
                />
              </div>

              <h3>Our representative will get in touch with you shortly</h3>

              <button
                href="/"
                onClick={handleClick}
                className="free_back thank_you_back"
              >
                Go back
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Thankyou;
